import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import {
  IoHomeOutline,
  IoHome,
  IoPulseOutline,
  IoPulse,
  IoListOutline,
  IoList,
  IoPeopleOutline,
  IoPeople,
  IoPersonOutline,
  IoPerson,
} from "react-icons/io5";

const MobileAppBar = () => {
  const router = useRouter();

  const navItems = [
    {
      title: "Home",
      path: "/",
      icon: <IoHomeOutline className="text-2xl" />,
      activeIcon: <IoHome className="text-2xl" />,
    },
    {
      title: "Predictions",
      path: "/predictions",
      icon: <IoPulseOutline className="text-2xl" />,
      activeIcon: <IoPulse className="text-2xl" />,
    },
    {
      title: "Promises",
      path: "/promises",
      icon: <IoListOutline className="text-2xl" />,
      activeIcon: <IoList className="text-2xl" />,
    },
    {
      title: "Predictors",
      path: "/predictors",
      icon: <IoPeopleOutline className="text-2xl" />,
      activeIcon: <IoPeople className="text-2xl" />,
    },
    {
      title: "Profile",
      path: "/profile",
      icon: <IoPersonOutline className="text-2xl" />,
      activeIcon: <IoPerson className="text-2xl" />,
    },
  ];

  const isActive = (path) => {
    if (path === "/") return router.pathname === "/";
    return router.pathname.startsWith(path);
  };

  return (
    <div
      style={{ fontFamily: "Noto Sans Armenian" }}
      className="md:hidden fixed bottom-0 left-0 right-0 z-[100] bg-white/95 dark:bg-[#030014]/95 backdrop-blur-xl border-t border-slate-200/80 dark:border-white/10 px-4 pb-safe pt-2 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]"
    >
      <div className="flex justify-between items-center max-w-md mx-auto h-[60px]">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              href={item.path}
              className={`flex flex-col items-center justify-center gap-1 min-w-[64px] transition-all duration-300 ${
                active
                  ? "text-[#0033FF] font-bold scale-105"
                  : "text-slate-500 dark:text-slate-400 hover:text-[#0033FF]"
              }`}
            >
              <div className="transition-all duration-300">
                {active ? item.activeIcon : item.icon}
              </div>
              <span
                className={`text-[10px] font-bold tracking-tight uppercase ${
                  active ? "opacity-100" : "opacity-70"
                }`}
              >
                {item.title === "Home"
                  ? "Գլխավոր"
                  : item.title === "Predictions"
                    ? "Կանխատես"
                    : item.title === "Promises"
                      ? "Խոստում"
                      : item.title === "Predictors"
                        ? "Կանխատեսող"
                        : "Պրոֆիլ"}
              </span>
              {active && (
                <div className="w-1.5 h-1.5 bg-[#0033FF] rounded-full mt-0.5" />
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileAppBar;
